import { Check, Globe } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { changeLanguage } from '@/lib/intl/i18n'

export function LanguageSwitch() {
  const { t, i18n } = useTranslation()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          aria-label={t('LANGUAGE')}
          className="flex size-11 shrink-0 items-center justify-center rounded-lg transition-colors hover:text-[#FF7300] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          type="button"
        >
          <Globe className="size-5 shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          className="flex min-h-11 justify-between"
          onSelect={() => changeLanguage('en')}
        >
          {t('ENGLISH')}
          {i18n.language === 'en' && <Check size={16} />}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex min-h-11 justify-between"
          onSelect={() => changeLanguage('de')}
        >
          {t('GERMAN')}
          {i18n.language === 'de' && <Check size={16} />}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex min-h-11 justify-between"
          onSelect={() => changeLanguage('pt')}
        >
          {t('PORTUGUESE')}
          {i18n.language === 'pt' && <Check size={16} />}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex min-h-11 justify-between"
          onSelect={() => changeLanguage('es')}
        >
          {t('SPANISH')}
          {i18n.language === 'es' && <Check size={16} />}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex min-h-11 justify-between"
          onSelect={() => changeLanguage('ru')}
        >
          {t('RUSSIAN')}
          {i18n.language === 'ru' && <Check size={16} />}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex min-h-11 justify-between"
          onSelect={() => changeLanguage('uz')}
        >
          {t('UZBEK')}
          {i18n.language === 'uz' && <Check size={16} />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
